import { deepClone } from 'valtio/utils';

export const resetStore = <T extends object>(
  store: T,
  initialStore: T,
  excludeKeys: (keyof T)[] = []
) => {
  /** We need to use deepClone here to prevent assigning objects references from initialStore (it's readonly).
   * So we want to avoid a situation where for instance, in authStore, we could assign authStore['profile'] = initialAuthStore['profile']
   * so it would hold a reference to frozen initial property (readonly) - making it impossible to spread.*/
  const resetObj = deepClone(initialStore);
  const typedKeys = Object.keys(resetObj) as (keyof T)[];
  typedKeys
    .filter((key) => !excludeKeys.includes(key))
    .forEach((key) => {
      store[key] = resetObj[key];
    });
};
